import { inject, Signal } from '@angular/core';

import { CcsHelpResourceService } from '../services';

import { ResourceLink } from '@shared/interfaces';

interface CcsHelpState {
  helpLinks: Signal<ResourceLink[]>;
  isLoading: Signal<boolean>;
}

export const ccsHelpState = (): CcsHelpState => {
  const ccsHelpResourceService = inject(CcsHelpResourceService);

  return {
    helpLinks: ccsHelpResourceService.helpLinks,
    isLoading: ccsHelpResourceService.isLoading,
  };
};
